import Icon from '../components/Icon.vue'

Icon.register({
  'car-alt': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M438.7 212.3c24.1 9.2 41.3 32.3 41.3 59.7v48c0 16.1-6.2 30.7-16 41.9v54.1c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-256v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-54.1c-9.8-11.3-16-25.8-16-41.9v-48c0-27.3 17.2-50.5 41.3-59.7l11.2-28.1 19.9-49.8c17.1-42.8 57.9-70.4 104-70.4h127c46.1 0 86.9 27.6 104 70.4l19.9 49.8zM131.9 158.2l-19.9 49.8h256l-19.9-49.8c-7.3-18.2-24.9-30.2-44.6-30.2h-127c-19.6 0-37.3 12-44.6 30.2zM80 319.8c19.2 0 48 3.2 48-16 0-19.1-28.8-47.8-48-47.8s-32 12.8-32 31.9c0 19.1 12.8 31.9 32 31.9zM400 319.8c19.2 0 32-12.8 32-31.9 0-19.1-12.8-31.9-32-31.9s-48 28.7-48 47.8c0 19.1 28.8 16 48 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/car-alt.js
// module id = 1145
// module chunks = 0